import { Meta } from '@master/model/common/Meta'
import { RawKey } from '@master/annotation/RawKey'

export default class CommissionRecord extends Meta {
  @RawKey('_oid')
  oid = ''

  @RawKey('_commissionbatchoid')
  commissionBatchOid = ''

  @RawKey('count(*)')
  records: number = undefined

  ctm: number = undefined
  advCode = ''
  advName = ''
  policyNumber = ''
  clientName = ''
  productName = ''
  premiumAmt: number = undefined
  commissionAmt: number = undefined
  orCommissionAmt: number = undefined
  transactionType = ''
  level1ComAmt: number = undefined
  level2ComAmt: number = undefined
  level3ComAmt: number = undefined
  level4ComAmt: number = undefined
  introducerFullname = ''
  introducerComAmt: number = undefined
  vestingFullname = ''
  vestingComAmt: number = undefined
  servicingFullname = ''
  servicingComAmt: number = undefined
  paymentDateMillis: number = undefined
  statementDateMillis: number = undefined
  principal = ''
  remunerationType: number = undefined
  paid = ''
  taxInvoiceNo = ''
  batchRemark = ''
  remark = ''
}
